import { SendoutQueue, SendoutQueueItem } from "./sendoutQueueSlice"

export const getItem =
  (id: string) =>
  (state: SendoutQueue): SendoutQueueItem | undefined => {
    return state.find((item) => item.messageId === id)
  }
